import { once as _once } from './tools.js';
export class EventMap {
    constructor(map) {
        this.handlers = [];
        if (map) {
            if (map instanceof EventMap) {
                this.handlers = map.handlers.slice();
            }
            else {
                map && this.addEventsMap(map);
            }
        }
    }
    merge(map) {
        this.handlers = this.handlers.concat(map.handlers);
    }
    addEventsMap(map) {
        for (let names in map) {
            this.addEvent(names, map[names]);
        }
    }
    bubbleEvents(names) {
        for (let name of names.split(eventSplitter)) {
            this.addEvent(name, getBubblingHandler(name));
        }
    }
    addEvent(names, callback) {
        const { handlers } = this;
        for (let name of names.split(eventSplitter)) {
            handlers.push(new EventDescriptor(name, callback));
        }
    }
    subscribe(target, source) {
        for (let event of this.handlers) {
            on(source, event.name, event.callback, target);
        }
    }
    unsubscribe(target, source) {
        for (let event of this.handlers) {
            off(source, event.name, event.callback, target);
        }
    }
}
export class EventDescriptor {
    constructor(name, callback) {
        this.name = name;
        if (callback === true) {
            this.callback = getBubblingHandler(name);
        }
        else if (typeof callback === 'string') {
            this.callback =
                function localCallback() {
                    const handler = this[callback];
                    handler && handler.apply(this, arguments);
                };
        }
        else {
            this.callback = callback;
        }
    }
}
const _bubblingHandlers = {};
function getBubblingHandler(event) {
    return _bubblingHandlers[event] || (_bubblingHandlers[event] = function (a, b, c, d, e) {
        if (d !== void 0 || e !== void 0)
            trigger5(this, event, a, b, c, d, e);
        if (c !== void 0)
            trigger3(this, event, a, b, c);
        else
            trigger2(this, event, a, b);
    });
}
export class EventHandler {
    constructor(callback, context, next = null) {
        this.callback = callback;
        this.context = context;
        this.next = next;
    }
}
function listOff(_events, name, callback, context) {
    const head = _events[name];
    let filteredHead, prev;
    for (let ev = head; ev; ev = ev.next) {
        if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
            (context && context !== ev.context)) {
            prev = ev;
            filteredHead || (filteredHead = ev);
        }
        else {
            if (prev)
                prev.next = ev.next;
        }
    }
    if (head !== filteredHead)
        _events[name] = filteredHead;
}
function listSend2(head, a, b) {
    for (let ev = head; ev; ev = ev.next)
        ev.callback.call(ev.context, a, b);
}
function listSend3(head, a, b, c) {
    for (let ev = head; ev; ev = ev.next)
        ev.callback.call(ev.context, a, b, c);
}
function listSend4(head, a, b, c, d) {
    for (let ev = head; ev; ev = ev.next)
        ev.callback.call(ev.context, a, b, c, d);
}
function listSend5(head, a, b, c, d, e) {
    for (let ev = head; ev; ev = ev.next)
        ev.callback.call(ev.context, a, b, c, d, e);
}
function listSend6(head, a, b, c, d, e, f) {
    for (let ev = head; ev; ev = ev.next)
        ev.callback.call(ev.context, a, b, c, d, e, f);
}
export function on(source, name, callback, context) {
    if (callback) {
        const _events = source._events || (source._events = Object.create(null));
        _events[name] = new EventHandler(callback, context, _events[name]);
    }
}
export function once(source, name, callback, context) {
    if (callback) {
        const once = _once(function () {
            off(source, name, once);
            callback.apply(this, arguments);
        });
        once._callback = callback;
        on(source, name, once, context);
    }
}
export function off(source, name, callback, context) {
    const { _events } = source;
    if (_events) {
        if (callback || context) {
            if (name) {
                listOff(_events, name, callback, context);
            }
            else {
                for (let name in _events) {
                    listOff(_events, name, callback, context);
                }
            }
        }
        else if (name) {
            _events[name] = void 0;
        }
        else {
            source._events = void 0;
        }
    }
}
const eventSplitter = /\s+/;
export function strings(api, source, events, callback, context) {
    if (eventSplitter.test(events)) {
        const names = events.split(eventSplitter);
        for (let name of names)
            api(source, name, callback, context);
    }
    else
        api(source, events, callback, context);
}
export function trigger2(self, name, a, b) {
    const { _events } = self;
    if (_events) {
        const queue = _events[name], { all } = _events;
        listSend2(queue, a, b);
        listSend3(all, name, a, b);
    }
}
;
export function trigger3(self, name, a, b, c) {
    const { _events } = self;
    if (_events) {
        const queue = _events[name], { all } = _events;
        listSend3(queue, a, b, c);
        listSend4(all, name, a, b, c);
    }
}
;
export function trigger5(self, name, a, b, c, d, e) {
    const { _events } = self;
    if (_events) {
        const queue = _events[name], { all } = _events;
        listSend5(queue, a, b, c, d, e);
        listSend6(all, name, a, b, c, d, e);
    }
}
;
//# sourceMappingURL=eventsource.js.map